import { useDeleteContentMutation } from '@/services/api/endpoints/content';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  useDisclosure,
  Button,
  ModalProps,
} from '@chakra-ui/react'
import { useRef } from 'react'

type Props = {
  isOpen: boolean;
  contentId: string;
  onClose: () => void;
}
const DeleteDialog=(props:Props)=> {
  const cancelRef = useRef<HTMLDivElement|null>(null)
  const [deleteContent] = useDeleteContentMutation()

  const handleDelete = async() => {
    await deleteContent(props.contentId).unwrap()
    props.onClose()
  }
  return (
    <>
      <AlertDialog
        isOpen={props.isOpen}
        leastDestructiveRef={cancelRef}
        onClose={props.onClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              删除作品
            </AlertDialogHeader>

            <AlertDialogBody>
              确认删除作品吗？此操作将不可逆转
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button onClick={props.onClose}>
                取消
              </Button>
              <Button colorScheme='red' onClick={handleDelete} ml={3}>
                确认
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}

export default DeleteDialog